import { ITag, ITagPickerProps, TagPicker } from "@fluentui/react";
import React, { useEffect, useState } from "react";

type TaggedSearchDropdownProps = Pick<ITagPickerProps, "disabled"> & {
    selectedKey: string | undefined;
    options: TaggedDropdownOption[];
    placeholder?: string;
    onChange(item?: TaggedDropdownOption): void;
};

export type TaggedDropdownOption = Pick<ITag, "key" | "name">;

export const TaggedSearchDropdown: React.FunctionComponent<TaggedSearchDropdownProps> = (
    props: TaggedSearchDropdownProps
) => {
    const { selectedKey, options, placeholder, disabled, onChange } = props;

    const [selectedItems, setSelectedItems] = useState<TaggedDropdownOption[]>([]);

    useEffect(() => {
        const selectedItem = options.find((option: TaggedDropdownOption) => option.key === selectedKey);

        if (selectedItem) {
            setSelectedItems([selectedItem]);
        } else {
            setSelectedItems([]);
        }
    }, [options, selectedKey]);

    const callOnChange = (items?: TaggedDropdownOption[]): void => {
        onChange(items ? items[0] : undefined);
    };

    const filterSuggestions = (input: string, selection?: TaggedDropdownOption[]): TaggedDropdownOption[] => {
        const filteredOptions = filterOutSelectedOptions(selection);

        if (!input) {
            return filteredOptions;
        }

        return filteredOptions.filter((option: TaggedDropdownOption) =>
            option.name
                .toLowerCase()
                .split(" ")
                .some((namePart: string) => namePart.startsWith(input.toLowerCase()))
        );
    };

    const filterOutSelectedOptions = (selection?: TaggedDropdownOption[] | undefined): TaggedDropdownOption[] => {
        return options.filter((option: TaggedDropdownOption) => !selection?.includes(option));
    };

    return (
        <TagPicker
            inputProps={{
                placeholder
            }}
            selectedItems={selectedItems}
            itemLimit={1}
            onChange={callOnChange}
            disabled={disabled}
            getTextFromItem={getTextFromItem}
            pickerSuggestionsProps={{
                noResultsFoundText: "No data"
            }}
            onResolveSuggestions={filterSuggestions}
            onEmptyResolveSuggestions={filterOutSelectedOptions}
        />
    );
};

const getTextFromItem = (item: TaggedDropdownOption) => item.name;
